import { Country } from "./country";

export class Bank
{
    accountNumber?: string;
    sortCode?: string;
    iBan?: string;
    swiftCode?: string;
    bankCode?: string;
    name?: string;
    address1?: string;
    address2?: string;
    address3?: string;
    city?: string;
    province?: string;
    postCode?: string;
    country?: Country;
    countryId?: string;
    swiftCodeBIC?: string;
    sortCodeUK?: string;
    reference?: string;
    status?: number;
    bankAccountType?: number;
}